module.exports = __webpack_public_path__ + "img/icomoon.4fcffe35.svg";